import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HomeRoutingModule } from './home-routing.module';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';
import { HomeComponent } from './home.component';
import { HomebannersComponent } from './homebanners/homebanners.component';
import { HomecategoriesComponent } from './homecategories/homecategories.component';
import { HomerecommendedComponent } from './homerecommended/homerecommended.component';
import { HometypekitchenComponent } from './hometypekitchen/hometypekitchen.component';
import { HomeselectedComponent } from './homeselected/homeselected.component';
import { HomeblogComponent } from './homeblog/homeblog.component';
import { HomeAppAdComponent } from './home-app-ad/home-app-ad.component';
import { LastactivitiesComponent } from './lastactivities/lastactivities.component';
import { SelectedCardComponent } from './homeselected/selected-card/selected-card.component';
import {DirectivesModule} from "../../directives/directives.module";
import { HomelastaddedComponent } from './homelastadded/homelastadded.component';
import { LastAddedCardComponent } from './homelastadded/last-added-card/last-added-card.component';
import { SwiperDirective } from './../../directives/swiper.directive';

@NgModule({
  declarations: [
    HomeComponent,
    HomebannersComponent,
    HomecategoriesComponent,
    HomerecommendedComponent,
    HometypekitchenComponent,
    HomeselectedComponent,
    LastactivitiesComponent,
    HomeblogComponent,
    SelectedCardComponent,
    HomeAppAdComponent,
    HomelastaddedComponent,
    LastAddedCardComponent,
    SwiperDirective
  ],
  imports: [
    CommonModule,
    HomeRoutingModule,
    DirectivesModule,
    NgxSkeletonLoaderModule.forRoot({
      animation: 'pulse',
      loadingText: 'Loading',
    }),
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class HomeModule { }
